export const PHRASES_ZEN = [
  "L'esprit est comme l'eau : quand il est calme, il reflète la beauté du monde.",
  "Le secret du bonheur, c'est d'aligner ses pensées avec le moment présent.",
  "Le calme est une super-puissance. Respire et laisse aller.",
  "Rien n'est permanent dans ce monde, pas même nos soucis.",
  "Sois le changement que tu veux voir dans ta vie aujourd'hui.",
  "Le bonheur n'est pas une destination à atteindre, mais une manière de voyager.",
  "Un voyage de mille lieues commence toujours par un premier pas.",
  "Prends le temps de ralentir. Tout ce qui doit t'arriver arrivera à point nommé.",
  "La paix intérieure commence au moment où tu choisis de ne pas laisser les autres contrôler tes émotions.",
  "La seule chose sur laquelle tu as un contrôle total, c'est ton attitude présente.",
  "Ne cherche pas à suivre les traces des anciens, cherche ce qu'ils ont cherché.",
  "Le silence n'est pas vide, il est plein de réponses.",
  "Accepte ce qui est, laisse aller ce qui était, et aie confiance en ce qui sera.",
  "La simplicité est la clé de l'élégance et de la paix de l'esprit.",
  "Chaque matin, nous naissons à nouveau. Ce que nous faisons aujourd'hui est ce qui importe le plus.",
  "Cultive ton propre jardin intérieur, les papillons viendront d'eux-mêmes.",
  "Les nuages passent, mais le ciel bleu reste toujours là.",
  "La patience est la forme la plus haute de la sagesse.",
  "Si tu es fatigué, apprends à te reposer, pas à abandonner.",
  "Donne de la valeur à ce que tu as déjà, et la vie t'apportera le reste.",
  "Il n'y a pas de chemin vers la paix, la paix est le chemin.",
  "Regarde le monde avec les yeux de l'émerveillement et tout deviendra magique.",
  "L'art de vivre consiste à abandonner ce qui nous retient sans perdre ce qui nous fait grandir.",
  "Vis comme si tu n'avais rien à prouver et tout à partager.",
  "Un esprit détendu apporte de la clarté dans les situations les plus floues.",
  "La douceur surmonte la dureté, la flexibilité brise la rigidité.",
  "Sois doux avec toi-même. Tu fais de ton mieux, et cela suffit amplement.",
  "Ce qui est à toi te trouvera, ce qui ne l'est pas s'éloignera de lui-même.",
  "Apprends à écouter le vent, il murmure des vérités que la raison ignore.",
  "Le plus grand pas vers une vie sereine est d'alléger ses attentes.",
  "Termine chaque journée avec un cœur reconnaissant et un esprit apaisé."
];